var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70233 2H15.8268L17.9129 3.9883L20.8442 3.98833C21.6704 3.98833 22.4693 4.30084 23.0635 4.86724C23.659 5.43476 24 6.21174 24 7.02926V18.9591C24 19.7766 23.659 20.5536 23.0635 21.1211C22.4693 21.6875 21.6704 22 20.8442 22H4.15581C3.32964 22 2.53071 21.6875 1.93645 21.1211C1.34104 20.5536 1 19.7766 1 18.9591V7.02926C1 6.21175 1.34104 5.43476 1.93645 4.86724C2.53071 4.30083 3.32964 3.98833 4.15581 3.98833L6.61628 3.9883L8.70233 2ZM9.56867 4.10526L7.48262 6.09356L4.15581 6.09359C3.87548 6.09359 3.61322 6.20005 3.42506 6.37939C3.23805 6.55764 3.13953 6.79212 3.13953 7.02926V18.9591C3.13953 19.1962 3.23805 19.4307 3.42506 19.6089C3.61322 19.7883 3.87548 19.8947 4.15581 19.8947H20.8442C21.1245 19.8947 21.3868 19.7883 21.5749 19.6089C21.7619 19.4307 21.8605 19.1962 21.8605 18.9591V7.02926C21.8605 6.79212 21.7619 6.55764 21.5749 6.37939C21.3868 6.20005 21.1245 6.09359 20.8442 6.09359L17.0465 6.09356L14.9605 4.10526H9.56867Z",
    fill: "#303141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3449 12.5263C16.3449 14.83 14.5399 16.6395 12.3838 16.6395C10.2277 16.6395 8.42271 14.83 8.42271 12.5263C8.42271 10.2227 10.2277 8.41318 12.3838 8.41318C14.5399 8.41318 16.3449 10.2227 16.3449 12.5263Z",
    stroke: "#303141",
    strokeWidth: 2.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.79b143cc73d328a0802dcc5017908739.svg";
export { ForwardRef as ReactComponent };